class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    this.lazyLoadController = new AbortController();
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    if (this.hasRenderedContents) return;

    fetch(this.dataset.url, { signal: this.lazyLoadController.signal })
      .then((response) => response.text())
      .then((html) => {
        if (this.hasRenderedContents) return;
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");

        document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
      })
      .catch((e) => {
        if (e && e.name === "AbortError") return;
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.hasRenderedContents = true;
    if (this.lazyLoadController) this.lazyLoadController.abort();
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      const sectionHtml =
        parsedState.sections && parsedState.sections[section.id];
      if (!element || !sectionHtml) return;
      const inner = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (inner != null) element.innerHTML = inner;
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
